import React, { useState, useRef, useEffect, ReactNode } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import useUserLogin from "../../hooks/UserLoginhook";

interface CustomDropdownProps {
  options: { label?: ReactNode; value: string }[];
  onSelect: (value: string) => void;
  isActive?: boolean;
}

const TransactionDropdown: React.FC<CustomDropdownProps> = ({
  options,
  onSelect,
  isActive,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const { customColor } = useUserLogin();
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (value: string) => {
    onSelect(value); // Call the onSelect prop
    setIsOpen(false); // Close the dropdown after selection
    setHoveredIndex(null);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative px-2 font-sans" ref={dropdownRef}>
      <div
        className="rounded-md p-2 cursor-pointer bg-transparent flex items-center justify-between text-custom-petite "
        onClick={toggleDropdown}
      >
        <div className="flex items-center gap-3 hover:text-white">
          Transactions <MdKeyboardArrowDown />
        </div>
      </div>
      {isOpen && (
        <div className="absolute z-10 w-48 mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
          <div className="flex flex-col">
            {options.map((option, index) => (
              <div
                key={option.value}
                className={`flex items-center px-4 py-2 gap-2 cursor-pointer text-custom-petite hover:text-white hover:bg-custom-default-hover hover:rounded-md text-black font-thin`}
                style={{
                  backgroundColor: hoveredIndex === index ? customColor : "",
                  transition: "background-color 0.3s",
                }}
                onClick={() => handleSelect(option.value)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {option.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionDropdown;
